module.exports = __webpack_public_path__ + "static/image22@2x-b961366800410a3b573ad949d036ee7f.jpg";